import styled from 'styled-components';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
`;
Wrapper.displayName = 'Wrapper';

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
Wrapper.displayName = 'Wrapper';

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 13px;
  width: 89px;
`;
CancelButton.displayName = 'CancelButton';

export const CustomBlueButton = styled(Button)`
  width: 89px;
`;
CustomBlueButton.displayName = 'CustomBlueButton';

export const WrapperButtons = styled.div`
  display: flex;
  flex-direction: row;
`;
WrapperButtons.displayName = 'WrapperButtons';

export const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.jobDetailTitle};
  margin-right: 12px;
  padding-left: 15px;
`;
Title.displayName = 'Title';

export const Id = styled.div`
  border-radius: 2px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px ${({ theme }) => theme.borders.importanceMeter};
  background-color: ${({ theme }) => theme.backgrounds.attributeTag};
  font-size: 11.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.attributeTag};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 12px;
  min-width: 78px;
`;
Id.displayName = 'Id';
